export default "__VITE_ASSET__ewgVldAD__"